import React from 'react';
import { useRecoilValue } from 'recoil';
import { toViewPriceFnState } from '../../recoil/atoms';
import { ShopifyCart } from '../../models/ShopifyCart.model';
import styles from './OrderTotal.module.scss';

interface Props {
  cart?: ShopifyCart;
}

export const OrderTotal: React.FC<Props> = ({ cart }) => {
  const toViewPriceFn = useRecoilValue(toViewPriceFnState);
  const displayPrice = (price: number | undefined) => (price !== undefined ? toViewPriceFn(price) : '~');
  const displayTotal = cart?.totalPrice ?? 0;

  return (
    <div className={styles.hlCartTotalLine}>
      <span>Total</span>
      <span className={styles.dollarTotal}>
        <span>{cart?.currency?.code ?? ''}</span>
        {displayPrice(displayTotal)}
      </span>
    </div>
  );
};

export default OrderTotal;
